(function () {
  "use strict";

  const config = {
    defaultLimit: 3,
    supportMessage:
      "Kindly contact our customer support team on WhatsApp at +91-9329773003 for bulk buying. Thank you",
    limitMessage:
      "You can add only {limit} quantity of this product. " +
      "Kindly contact our customer support team on WhatsApp at +91-9329773003 for bulk buying. Thank you",
  };

  const nativeFetch = window.fetch.bind(window);
  let checkingRequest = false;

  function normalizeUrl(input) {
    const rawUrl = typeof input === "string" ? input : input && input.url;
    if (!rawUrl) return "";

    try {
      return new URL(rawUrl, window.location.origin).pathname;
    } catch (error) {
      return rawUrl;
    }
  }

  function toNumber(value, fallback = 0) {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function getConfiguredLimits() {
    return window.RAS_PRODUCT_LIMITS || {};
  }

  function getVariantProductMap() {
    return window.RAS_VARIANT_PRODUCT_MAP || {};
  }

  function showLimitMessage(limit) {
    const message = config.limitMessage.replace("{limit}", String(limit));
    window.alert(message || config.supportMessage);
  }

  function itemIdentity(item) {
    const productId = toNumber(item.product_id || item.productId);
    const variantId = toNumber(item.variant_id || item.variantId || item.id);

    return {
      productId,
      variantId,
      key: item.key,
    };
  }

  function getProductLimit(productId, variantId, form) {
    const productLimits = getConfiguredLimits();
    const formLimit = toNumber(form && form.dataset.productLimit);
    if (formLimit > 0) return formLimit;

    const productLimit = toNumber(productLimits[String(productId)]);
    if (productLimit > 0) return productLimit;

    const variantLimit = toNumber(productLimits[String(variantId)]);
    if (variantLimit > 0) return variantLimit;

    return toNumber(productLimits.default, config.defaultLimit);
  }

  function cartQuantityForProduct(cart, productId, variantId) {
    return cart.items.reduce((total, item) => {
      const identity = itemIdentity(item);

      if (productId && identity.productId === productId) {
        return total + item.quantity;
      }

      if (!productId && variantId && identity.variantId === variantId) {
        return total + item.quantity;
      }

      return total;
    }, 0);
  }

  function getFormProductId(form, variantId) {
    const explicitProductId =
      form.querySelector('[name="product-id"]')?.value ||
      form.dataset.productId ||
      form.closest("[data-product-id]")?.dataset.productId ||
      getVariantProductMap()[String(variantId)];

    return toNumber(explicitProductId);
  }

  function getFormQuantity(form) {
    const quantityInput = form.querySelector('[name="quantity"]');
    return Math.max(1, toNumber(quantityInput && quantityInput.value, 1));
  }

  function getQuantityInput(button) {
    const quantityWrapper = button.closest("quantity-input, .quantity, .cart-item__quantity");
    return quantityWrapper && quantityWrapper.querySelector("input");
  }

  function getLineFromQuantityInput(input) {
    const fromDataset = toNumber(input.dataset.index || input.dataset.line);
    if (fromDataset > 0) return fromDataset;

    const idMatch = String(input.id || "").match(/(?:Quantity|quantity)-(\d+)/i);
    if (idMatch) return toNumber(idMatch[1]);

    const nameMatch = String(input.name || "").match(/updates\[(\d+)\]/);
    return nameMatch ? toNumber(nameMatch[1]) : 0;
  }

  function setLineQuantityValue(line, value) {
    const selectors = [
      `#Quantity-${line}`,
      `#Drawer-quantity-${line}`,
      `[data-index="${line}"][name="updates[]"]`,
      `[data-line="${line}"][name="updates[]"]`,
    ];

    document.querySelectorAll(selectors.join(",")).forEach((input) => {
      input.value = String(Math.max(0, value));
    });
  }

  async function getCart() {
    return nativeFetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store",
    }).then((response) => response.json());
  }

  async function canAddFromForm(form) {
    const variantId = toNumber(form.querySelector('[name="id"]')?.value);
    if (!variantId) return true;

    const productId = getFormProductId(form, variantId);
    const quantityToAdd = getFormQuantity(form);
    const cart = await getCart();
    const limit = getProductLimit(productId, variantId, form);
    const currentQuantity = cartQuantityForProduct(cart, productId, variantId);

    if (currentQuantity + quantityToAdd <= limit) return true;

    showLimitMessage(limit);
    return false;
  }

  function parseRequestBody(body) {
    if (!body) return {};

    if (body instanceof FormData) {
      const parsed = {};
      body.forEach((value, key) => {
        parsed[key] = value;
      });
      return parsed;
    }

    if (body instanceof URLSearchParams) {
      return Object.fromEntries(body.entries());
    }

    if (typeof body === "string") {
      try {
        return JSON.parse(body);
      } catch (error) {
        return Object.fromEntries(new URLSearchParams(body).entries());
      }
    }

    return body;
  }

  function getRequestBody(input, init) {
    if (init && init.body) return init.body;
    if (input && input.bodyUsed === false && input.clone) return input.clone().text();
    return null;
  }

  async function canAddFromRequest(body) {
    const cart = await getCart();
    const additions = body.items || [{
      id: body.id,
      quantity: body.quantity,
      productId: body["product-id"] || body.product_id || body.productId,
    }];

    for (const addition of additions) {
      const variantId = toNumber(addition.id);
      const productId = toNumber(
        addition.productId ||
        addition.product_id ||
        addition["product-id"] ||
        getVariantProductMap()[String(variantId)]
      );
      const quantityToAdd = Math.max(1, toNumber(addition.quantity, 1));
      const limit = getProductLimit(productId, variantId);
      const currentQuantity = cartQuantityForProduct(cart, productId, variantId);

      if (currentQuantity + quantityToAdd > limit) {
        showLimitMessage(limit);
        return false;
      }
    }

    return true;
  }

  async function canChangeCartQuantity(body) {
    const requestedQuantity = toNumber(body.quantity);
    if (!requestedQuantity || requestedQuantity < 1) return true;

    const cart = await getCart();
    const lineIndex = toNumber(body.line) - 1;
    const lineItem = cart.items[lineIndex];
    if (!lineItem) return true;

    const identity = itemIdentity(lineItem);
    const limit = getProductLimit(identity.productId, identity.variantId);
    const otherQuantity = cart.items.reduce((total, item, index) => {
      return index === lineIndex || item.product_id !== identity.productId
        ? total
        : total + item.quantity;
    }, 0);

    if (otherQuantity + requestedQuantity <= limit) return true;

    setLineQuantityValue(body.line, Math.max(0, limit - otherQuantity));
    showLimitMessage(limit);
    return false;
  }

  async function canIncreaseCartLine(input) {
    const line = getLineFromQuantityInput(input);
    if (!line) return true;

    const cart = await getCart();
    const lineItem = cart.items[line - 1];
    if (!lineItem) return true;

    const identity = itemIdentity(lineItem);
    const limit = getProductLimit(identity.productId, identity.variantId);
    const otherQuantity = cart.items.reduce((total, item, index) => {
      return index === line - 1 || item.product_id !== identity.productId
        ? total
        : total + item.quantity;
    }, 0);
    const currentLineQuantity = toNumber(input.value, lineItem.quantity);
    const maxLineQuantity = Math.max(0, limit - otherQuantity);

    if (currentLineQuantity + 1 <= maxLineQuantity) return true;

    setLineQuantityValue(line, maxLineQuantity);
    showLimitMessage(limit);
    return false;
  }

  async function canIncreaseProductFormQuantity(input) {
    const form = input.form || input.closest('form[action*="/cart/add"]');
    if (!form) return true;

    const variantId = toNumber(form.querySelector('[name="id"]')?.value);
    if (!variantId) return true;

    const productId = getFormProductId(form, variantId);
    const currentFormQuantity = Math.max(1, toNumber(input.value, 1));
    const cart = await getCart();
    const limit = getProductLimit(productId, variantId, form);
    const currentCartQuantity = cartQuantityForProduct(cart, productId, variantId);

    if (currentCartQuantity + currentFormQuantity + 1 <= limit) return true;

    input.value = String(Math.max(1, limit - currentCartQuantity));
    showLimitMessage(limit);
    return false;
  }

  document.addEventListener(
    "click",
    function (event) {
      const button = event.target.closest('button[name="plus"], button[data-quantity-plus]');
      if (!button) return;

      const input = getQuantityInput(button);
      if (!input) return;

      const isCartQuantity = Boolean(button.closest("cart-drawer, cart-items, .cart"));
      const isProductFormQuantity = Boolean(input.closest('form[action*="/cart/add"]') || input.form);
      if (!isCartQuantity && !isProductFormQuantity) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (button.dataset.rasLimitChecking === "true") return;
      button.dataset.rasLimitChecking = "true";

      const quantityAllowed = isCartQuantity
        ? canIncreaseCartLine(input)
        : canIncreaseProductFormQuantity(input);

      quantityAllowed
        .then((allowed) => {
          if (!allowed) return;

          const previousValue = input.value;
          if (input.stepUp) {
            input.stepUp();
          } else {
            input.value = String(toNumber(input.value) + 1);
          }

          if (previousValue !== input.value) {
            input.dispatchEvent(new Event("change", { bubbles: true }));
          }
        })
        .finally(() => {
          delete button.dataset.rasLimitChecking;
        });
    },
    true
  );

  document.addEventListener(
    "submit",
    function (event) {
      const form = event.target.closest('form[action*="/cart/add"]');
      if (!form || form.dataset.rasLimitChecking === "true") return;

      event.preventDefault();
      event.stopImmediatePropagation();
      form.dataset.rasLimitChecking = "true";

      canAddFromForm(form)
        .then((allowed) => {
          if (allowed) {
            form.requestSubmit ? form.requestSubmit() : form.submit();
          }
        })
        .finally(() => {
          delete form.dataset.rasLimitChecking;
        });
    },
    true
  );

  window.fetch = async function (input, init) {
    const path = normalizeUrl(input);

    if (checkingRequest) {
      return nativeFetch(input, init);
    }

    if (path.endsWith("/cart/add.js") || path.endsWith("/cart/change.js")) {
      checkingRequest = true;

      try {
        const rawBody = await getRequestBody(input, init);
        const body = parseRequestBody(rawBody);
        const allowed = path.endsWith("/cart/add.js")
          ? await canAddFromRequest(body)
          : await canChangeCartQuantity(body);

        if (!allowed) {
          return new Response(JSON.stringify({ status: 422, message: "Product quantity limit reached" }), {
            status: 422,
            headers: { "Content-Type": "application/json" },
          });
        }
      } finally {
        checkingRequest = false;
      }
    }

    return nativeFetch(input, init);
  };
})();
